import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDropDown = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M13.3535 3.64642L14.7678 5.06064L8.06065 11.7677L1.35355 5.06064L2.76776 3.64642L8.06065 8.93932L13.3535 3.64642Z",
		fill: "#333333"
	})
});
export default SvgDropDown;
